import React from 'react'
import FilterHeader from './filterHeader'

/**
 * Sticky search/filter header shared by the mobile list pages ("Mine turer",
 * "Mine skift"). Wraps FilterHeader with the sticky positioning + background
 * used on both pages, so the markup only needs to live in one place.
 *
 * Padding scales up a bit on tablet-sized viewports (md+) to match the wider
 * content column from MobileLayout.
 */
const MobileSearchHeader = ({ searchValue, onSearchChange, onFilterClick, placeholder, activeFilterCount }) => {
   return (
      <div className="sticky top-0 z-10 bg-gray-100 p-4 pb-2 md:p-6 md:pb-2">
         <FilterHeader
            searchValue={searchValue}
            onSearchChange={onSearchChange}
            onFilterClick={onFilterClick}
            placeholder={placeholder}
            activeFilterCount={activeFilterCount}
         />
      </div>
   )
}

export default MobileSearchHeader
